<template>
    <BaseNotification theme="warning" hide-dismiss data-testid="prompt-version-test-banner" class="shrink-0 w-full">
        <template #content>
            <div class="body-small">
                <strong>Prompt version testing:</strong>
                <template v-if="enteredViaEntrance">
                    You are testing a <BaseChip size="xs">ChatEntrance</BaseChip> prompt, but this simple banner cannot know which one (sorry!). It only knows the target prompt you
                    ended up on: <strong>{{ internalName }}</strong> ({{ callCode }}) (always the published version, which is currently {{ versionLabel }})
                    <p class="mt-2">
                        <em>{{ staffOnlyNotice }}</em>
                    </p>
                </template>
                <template v-else>
                    You are viewing a test of <strong>{{ internalName }}</strong> ({{ callCode }}) <BaseChip>{{ versionLabel }}</BaseChip>
                    <template v-if="isPublishedVersion">
                        <BaseChip class="ml-3">← this is the <em>current published</em> version</BaseChip>
                        <p class="mt-2">
                            <em>{{ staffOnlyNotice }}</em>
                            <template v-if="settingsUrl">
                                To get the “Access Link” URL for this prompt, go to the
                                <!-- This server-rendered Django staff editor requires full-page navigation. -->
                                <a :href="settingsUrl" class="base-link font-semibold">Settings page</a>.
                            </template>
                        </p>
                    </template>
                    <template v-else>
                        <BaseChip class="ml-3"
                            >← (<strong>note:</strong> this is <strong><em>not</em></strong> the published version.)</BaseChip
                        >
                        <p class="mt-2">
                            <em>{{ staffOnlyNotice }}</em>
                        </p>
                    </template>
                </template>
            </div>
        </template>
    </BaseNotification>
</template>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";

// All props are required: the banner only renders when chat_source = PROMPT_VERSION_TEST
// (see chat/views.py), which means /coach/test/ created the chat with a verified prompt +
// history row. internal_name, call_code, and version_label are all guaranteed populated by
// the underlying Django model contracts.
defineProps<{
    isPublishedVersion: boolean;
    settingsUrl: string;
    callCode: string;
    internalName: string;
    versionLabel: string;
    enteredViaEntrance: boolean;
}>();

const staffOnlyNotice = "This internal page is only accessible to Valence staff — don’t share this link with customers (it won’t work).";
</script>
